import { cva } from 'class-variance-authority'

export const rootStyles = cva(
  `
    grid
    gap-4
    border-0
    min-w-0
  `
)

export const itemStyles = cva(
  `
    peer
    aspect-square
    h-4
    w-4
    rounded-full
    border
    border-primary
    text-neutral-700
    ring-offset-background
    focus:outline-none
    focus-visible:ring-2
    focus-visible:ring-ring
    focus-visible:ring-offset-2
    disabled:cursor-not-allowed
    disabled:opacity-50
    hover:cursor-pointer
  `
)

export const itemLabelStyles = cva(
  `
    text-sm
    font-normal
    text-neutral-600
    peer-data-[state=checked]:font-medium
    peer-data-[state=checked]:text-neutral-900
  `,
  {
    variants: {
      disabled: {
        true: 'text-neutral-400 peer-data-[state=checked]:text-neutral-400',
      },
    },
    defaultVariants: {
      disabled: false,
    },
  }
)

export const indicatorStyles = cva(
  `
    flex
    items-center
    justify-center
    w-full
    h-full
  `
)

export const iconStyles = cva(
  `
    fill-neutral-700
    text-neutral-700
  `
)

export const itemContainerStyles = cva(
  `
    flex
    items-center
    gap-2
  `
)
